import { environment, getUser, setUser } from '@10000/react'

const request = (path, body, region = 'AP') => {
  const base = path.startsWith('/') ? '' : 'http' + environment.hostUrl(region).substring(2)
  const url = `${base}${path}`
  const token = getUser()?.token

  return fetch(url, {
    method: body ? 'POST' : 'GET',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': 'Bearer: ' + token })
    }
  })
    .then(response => response.json())
    .then(result => {
      if(!result.success && !result.challenge) {
        // this should be new Error(result.message) but it seems like react-forms doesn't handle Error objects... :-\
        throw result.message
      }
      return result
    })
}

const persistUser = (persist = true) => result => {
  if(persist && result?.user) {
    setUser(result.user)
  }
  return result
}

export const authenticate = ({ username, password, token, session, code }, persist = true) => (
  request('authenticate', { username, password, token, session, code }).then(persistUser(persist))
)
export const signUp = (email, country, name, avatar, free) => request('signUp', { email, country, data: { name, avatar, free, country } })
export const createAccount = ({ email, code, userId, refreshToken, region, country, free }) => (
  request('createAccount', { email, code, userId, refreshToken, region, country, free, authenticate: true }, region).then(persistUser())
)
export const resendCode = email => request('resendCode', { email })
export const forgotPassword = (email, code, password) => request('forgotPassword', { email, code, password })
export const resendTemporaryPassword = (email) => request('resendTemporaryPassword', { email })
export const country = () => environment.development ? Promise.resolve({ country: 'AU', region: 'AP' }) : request('/country')

export const authRedirectUri = (region, provider = '', state) => `http${environment.hostUrl(region).substring(2)}authRedirect?provider=${provider}&state=${objectToBase64({ ...state, authRedirect: true })}`

export const objectToBase64 = source => btoa(JSON.stringify(source))
export const base64ToObject = source => {
  try {
    return JSON.parse(atob(source))
  } catch {
    return {}
  }
}